export interface IBrandAclGroup {
    key: string;
    label: string;
    items: string[];
}

export interface BrandAclRequest {
    key: string,
    name: string,
    nameDe: string,
    isDefault: boolean,
    isEnabled: boolean,
    acl: string[]
    desc: string,
    descDe: string,
}

export interface BrandAclResponse {
    id: number;
    key: string | null;
    name: string,
    nameDe: string,
    isDefault: boolean,
    isEnabled: boolean,
    acl: string[];
    createdAt: string;
    desc: string,
    descDe: string,
}

export const BRAND_ACL_GROUPS: IBrandAclGroup[] = [
    {
        key: 'briefing',
        label: 'Briefing',
        items: ['briefing_view', 'briefing_edit'],
    },
    {
        key: 'discovery',
        label: 'Discovery',
        items: ['discovery', 'bundle'],
    },
    {
        key: 'booking',
        label: 'Booking',
        items: ['contracts', 'booking'],
    },
    {
        key: 'manage',
        label: 'Manage',
        items: ['manage_approve', 'manage_view', 'manage_upload', 'manage_reschedule', 'manage_comments'],
    },
    {
        key: 'reporting',
        label: 'Reporting & content',
        items: ['measure', 'see_all_campaigns'],
    },
    {
        key: 'users',
        label: 'Users & access',
        items: ['user_management_create', 'user_management_edit', 'user_management_delete', 'assign_campaign_access'],
    },
    {
        key: 'global_brand',
        label: 'Global brand',
        items: ['global_manage', 'global_measure', 'global_dashboard', 'global_influencer_kpis', 'see_all_global_campaigns'],
    },
    {
        key: 'system',
        label: 'System',
        items: ['settings'],
    },
];